import Icon from 'veui/components/Icon'
import { IconReport } from 'dls-icons-vue'

Icon.register('report', IconReport)
